import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconMaximize = ({ width = 14, height = 14, color = colors.black }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect x='1.5' y='1.5' width='11' height='11' stroke={color} strokeWidth='1.5' />
        </svg>
    );
};

IconMaximize.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconMaximize;
